import React from 'react';

// Elegante SVG Icons
export const LeafIcon = ({ className = "w-6 h-6" }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <path d="M12 2C6.5 2 2 6.5 2 12c0 2.5 1 4.8 2.5 6.5C6 17 8.5 15 12 15s6 2 7.5 3.5C21 16.8 22 14.5 22 12c0-5.5-4.5-10-10-10z" />
    <path d="M12 15V22" />
    <path d="M12 2c0 5.5 2 8 5 10" />
    <path d="M12 2c0 5.5-2 8-5 10" />
  </svg>
);

export const DotIcon = ({ className = "w-2 h-2" }) => (
  <svg className={className} viewBox="0 0 8 8" fill="currentColor">
    <circle cx="4" cy="4" r="3" />
  </svg>
);

export const ArrowDownIcon = ({ className = "w-5 h-5" }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <path d="M12 5v14M5 12l7 7 7-7" />
  </svg>
);

export const QuoteIcon = ({ className = "w-10 h-10" }) => (
  <svg className={className} viewBox="0 0 40 40" fill="currentColor" opacity="0.3">
    <path d="M10 20c-2.2 0-4-1.8-4-4v-2c0-4.4 3.6-8 8-8h1v4h-1c-2.2 0-4 1.8-4 4v2h4v8H10zm16 0c-2.2 0-4-1.8-4-4v-2c0-4.4 3.6-8 8-8h1v4h-1c-2.2 0-4 1.8-4 4v2h4v8h-4z" />
  </svg>
);

export const PlantDecor = ({ className = "w-32 h-32", mirror = false }) => (
  <svg className={className} viewBox="0 0 100 100" fill="none" stroke="currentColor" strokeWidth="0.8" style={{ transform: mirror ? 'scaleX(-1)' : 'none' }}>
    <path d="M50 100V60" opacity="0.4" />
    <path d="M50 60Q30 55 25 30Q35 40 50 45" opacity="0.3" />
    <path d="M50 70Q70 60 80 35Q65 50 50 55" opacity="0.3" />
    <path d="M50 80Q25 75 15 55Q30 65 50 70" opacity="0.25" />
    <circle cx="50" cy="25" r="8" opacity="0.2" />
    <circle cx="30" cy="35" r="5" opacity="0.15" />
    <circle cx="75" cy="40" r="6" opacity="0.15" />
  </svg>
);

export const WaveDecor = ({ className = "w-full h-16" }) => (
  <svg className={className} viewBox="0 0 1200 100" fill="none" preserveAspectRatio="none">
    <path d="M0 50Q300 0 600 50T1200 50V100H0Z" fill="currentColor" opacity="0.05" />
  </svg>
);

export const SpaDrop = ({ className = "w-6 h-6" }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2C8 8 6 12 6 15a6 6 0 1012 0c0-3-2-7-6-13z" />
  </svg>
);

export const HandsIcon = ({ className = "w-8 h-8" }) => (
  <svg className={className} viewBox="0 0 32 32" fill="none" stroke="currentColor" strokeWidth="1.5">
    <path d="M8 20c-2 0-4-2-4-4s2-4 4-4c1 0 2 .5 3 1" />
    <path d="M24 20c2 0 4-2 4-4s-2-4-4-4c-1 0-2 .5-3 1" />
    <path d="M11 13c0-4 2-8 5-11 3 3 5 7 5 11v10c0 3-2 6-5 6s-5-3-5-6V13z" />
  </svg>
);

export const ClockIcon = ({ className = "w-5 h-5" }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <circle cx="12" cy="12" r="10" />
    <path d="M12 6v6l4 2" />
  </svg>
);

export const CheckIcon = ({ className = "w-5 h-5" }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M5 13l4 4L19 7" />
  </svg>
);

export const PlayIcon = ({ className = "w-12 h-12" }) => (
  <svg className={className} viewBox="0 0 48 48" fill="currentColor">
    <circle cx="24" cy="24" r="22" fill="none" stroke="currentColor" strokeWidth="2" />
    <path d="M18 14l16 10-16 10V14z" />
  </svg>
);

export const MapPinIcon = ({ className = "w-5 h-5" }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z" />
    <circle cx="12" cy="9" r="2.5" />
  </svg>
);

export const PhoneIcon = ({ className = "w-5 h-5" }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z" />
  </svg>
);

export const MailIcon = ({ className = "w-5 h-5" }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <rect x="2" y="4" width="20" height="16" rx="2" />
    <path d="M22 6l-10 7L2 6" />
  </svg>
);

export const MenuIcon = ({ className = "w-6 h-6" }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <path d="M4 6h16M4 12h16M4 18h16" />
  </svg>
);

export const CloseIcon = ({ className = "w-6 h-6" }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <path d="M18 6L6 18M6 6l12 12" />
  </svg>
);

export const StarIcon = ({ className = "w-5 h-5" }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
  </svg>
);